import Vue from 'vue';
import Axios from 'axios';
import { TiptapVuetifyPlugin } from 'tiptap-vuetify';
import 'tiptap-vuetify/dist/main.css';
import 'vuetify/dist/vuetify.min.css';
import DatetimePicker from 'vuetify-datetime-picker';
import App from './App.vue';
import router from './plugins/router';
import store from './plugins/store';
import vuetify from './plugins/vuetify';
import components from './components';
import 'roboto-fontface/css/roboto/roboto-fontface.css';
import 'material-design-icons-iconfont/dist/material-design-icons.css';
import '@/assets/scss/main.scss';

Vue.prototype.$http = Axios;
Vue.prototype.$http.defaults.baseURL = process.env.VUE_APP_API;
Vue.prototype.$http.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

// Check if the user is logged in and has a valid token
if (store.getters.isLogged && !store.getters.isExpired) {
  // eslint-disable-next-line
  Vue.prototype.$http.defaults.headers.common['Authorization'] =
    `Bearer ${store.getters.user.access_token}`;

  // Make an initial call to the current user's profile
  // If this fails, the token is invalid and the user is logged out immediately
  store.dispatch('get', 'User/Me').catch(() => {
    store.dispatch('logout');
    router.push('login');
  });
}

Vue.use(DatetimePicker);

Vue.use(TiptapVuetifyPlugin, {
  // the next line is important! You need to provide the Vuetify Object to this place.
  vuetify, // same as "vuetify: vuetify"
  // optional, default to 'md' (default vuetify icons before v2.0.0)
  iconsGroup: 'md',
});

// Register all global Vue components
Object.keys(components).forEach((key) => {
  Vue.component(key, components[key]);
});

// Ignore size warnings
Vue.config.productionTip = false;

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount('#app');
